// A stand-in sight vocabulary for the lab. speech-lab has no reader identity,
// so there is no `fluencyRecords` evidence to build a real map from; this one
// predicts the Dolch pre-primer and primer lists as sight words and leaves
// every other word `unobserved`, which is what makes the quiet markers show
// on a real dictation. Fixture, not pedagogy: the thresholds and statuses it
// produces are for exercising the page.
import {
  type SightMap,
  sightMap,
  type WordPrediction,
} from "@bindery/composition";

export const FIXTURE_MODEL_RELEASE = "fixture dolch-pre-primer+primer";

// Dolch pre-primer and primer lists, lowercased.
const DOLCH_SIGHT = `
  a and away big blue can come down find for funny go help here i in
  is it jump little look make me my not one play red run said see
  the three to two up we where yellow you all am are at ate be black
  brown but came did do eat four get good have he into like must new
  no now on our out please pretty ran ride saw say she so soon that
  there they this too under want was well went what white who will
  with yes
`
  .split(/\s+/)
  .filter((w) => w.length > 0);

// A few words a K–2 child says often and reads rarely, predicted unknown so
// the page shows the encoding-opportunity marker on a familiar word too.
const PREDICTED_UNKNOWN = `
  because beautiful favorite friend school through very would
`
  .split(/\s+/)
  .filter((w) => w.length > 0);

const prediction = (predictedKnown: boolean): WordPrediction => ({
  pKnown: predictedKnown ? 0.92 : 0.18,
  predictedKnown,
  modelRelease: FIXTURE_MODEL_RELEASE,
});

export const fixtureSightMap = (now: number): SightMap =>
  sightMap({
    records: [],
    predictions: new Map([
      ...DOLCH_SIGHT.map((w) => [w, prediction(true)] as const),
      ...PREDICTED_UNKNOWN.map((w) => [w, prediction(false)] as const),
    ]),
    now,
  });
